import React from 'react';
export function PaymentBadges() {
  return <div className="flex flex-wrap items-center justify-center gap-2 mt-4" data-id="element-214">
      {/* Visa */}
      <div className="bg-[#1A1F71] text-white rounded-md px-3 py-1.5 font-bold italic text-sm flex items-center justify-center shadow-sm" data-id="element-215">
        VISA
      </div>

      {/* Mastercard */}
      <div className="bg-gray-100 text-gray-800 rounded-md px-3 py-1.5 font-semibold text-xs flex items-center justify-center shadow-sm border border-gray-200 gap-1" data-id="element-216">
        <div className="flex -space-x-2" data-id="element-217">
          <div className="w-4 h-4 rounded-full bg-[#EB001B] opacity-90" data-id="element-218"></div>
          <div className="w-4 h-4 rounded-full bg-[#F79E1B] opacity-90" data-id="element-219"></div>
        </div>
        <span className="ml-1" data-id="element-220">mastercard</span>
      </div>

      {/* PayPal */}
      <div className="bg-[#003087] text-white rounded-md px-3 py-1.5 font-bold italic text-sm flex items-center justify-center shadow-sm" data-id="element-221">
        <span className="text-[#0079C1]" data-id="element-222">Pay</span>
        <span className="text-[#00457C]" data-id="element-223">Pal</span>
      </div>

      {/* Amex */}
      <div className="bg-[#006FCF] text-white rounded-md px-3 py-1.5 font-bold text-xs flex items-center justify-center shadow-sm" data-id="element-224">
        AMEX
      </div>

      {/* Apple Pay */}
      <div className="bg-black text-white rounded-md px-3 py-1.5 font-semibold text-sm flex items-center justify-center shadow-sm gap-1" data-id="element-225">
        <svg viewBox="0 0 384 512" className="w-3 h-3 fill-current" xmlns="http://www.w3.org/2000/svg" data-id="element-226">
          <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" data-id="element-227" />
        </svg>
        Pay
      </div>
    </div>;
}